import { Location } from 'src/app/model/location';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { Company } from 'src/app/model/company';
import { HandleError, HttpErrorHandlerService } from '../http-error-handler.service';
import { OrderStock } from 'src/app/model/OrderManagement/OrderStock/RewMaterials/OrderStock/order-stock';
import { Terms } from 'src/app/model/OrderManagement/OrderStock/RewMaterials/Terms/terms';
import { RequestView } from 'src/app/model/OrderManagement/OrderStock/RewMaterials/RequestView/request-view';
import { InventoryType } from 'src/app/model/FacilityManager/inventory-type';
import { ProductMatrix } from 'src/app/model/FacilityManager/product-matrix';
import { ReceiveDetail } from 'src/app/model/OrderManagement/Receive Order Stock/ReceiveDetail/receive-detail';
import { FormGroup } from '@angular/forms';
import { ViewCrateReceive } from 'src/app/model/OrderManagement/ManageCrates/CrateReceive/view-crate-receive';
import { Observable } from 'rxjs';
import { Signatory } from 'src/app/model/signatory';
import { DispatchedOrder } from 'src/app/model/OrderManagement/Dispatch Order/dispatched-order';
import { APIFactoryEndPoints } from 'src/app/common/apifactory-end-points';


@Injectable({
  providedIn: 'root'
})
export class OrderManagementContainerService {

  private handleError: HandleError


  constructor(
    private http: HttpClient,
    httpErrorHandle: HttpErrorHandlerService,
    private apiFactory: APIFactoryEndPoints

  ) {
    this.handleError = httpErrorHandle.createHandleError('OrderManagementContainerService');
  }
  getImage(url: string, img: String): any {

    return this.http.get<any>(url + img, { responseType: 'arraybuffer' as 'json' })
      .pipe(
        catchError(this.handleError('getImage', "SORRY"))
      );
  }
  getProductDetailByProductCode(url: string, productCode: number) {
    return this.http.get(url + "/" + productCode);
  }

  getAutoOrderData(url: string, invCode: number, locId: number) {
    return this.http.get<any>(url + '/' + invCode + '/' + locId);
  }


  getAllMakeToOrderDetailsByNos(url: string, orderNos: string[]) {
    return this.http.get(url + "/" + orderNos);
  }

  //ReceiveReturnMakeToOrder

  //New
  getMakeToOrderDetailsInitialData(url: string) {
    return this.http.get(url);
  }
  getReceiveMakeToOrderNoByDate(url: string, obj: RequestView) {
    return this.http.post(url, obj);
  }
  getReceiveMakeToOrderByOrderNo(url: string, orderNo: string) {
    return this.http.get(url + "/" + orderNo);
  }
  getProductDetailById(url: string, code: number) {
    return this.http.get(url + "/" + code);
  }
  getReturnMakeToOrderFromLocation(url: string, locId: number, orderNo: string) {
    return this.http.get(url + "/" + locId + "/" + orderNo);
  }
  //View
  getLocationsByParentCode(url: string, parentCode: any) {
    return this.http.get(url + "/" + parentCode);
  }
  returnMakeToOrderGetById(url: string, code: string) {
    return this.http.get(url + "/" + code);
  }
  //For export
  exportViewData(url: string, exportType: string, module: string, req: any) {
    return this.http.post(url + "/" + exportType + "/" + module, req, { responseType: 'arraybuffer' }).pipe(
      catchError(this.handleError('exportMasterData()', []))
    );
  }

  //ReceiveMakeToOrderPreveiw
  getGstSetupInfoByCompanyCode(url: string, companyCode: number) {
    return this.http.get(url + "/" + companyCode).pipe(
      catchError(this.handleError('getGstSetupInfoByCompanyCode', []))
    );
  }

  //Dispatch Make To Order

  changeStatusWithId(url: string, code: string) {
    return this.http.patch<any>(url + "/" + code, null);
  }
  getViewDispatchList(url: string, req: any) {
    return this.http.post(
      url,
      req,
      { responseType: 'json' }
    );
  }
  getDispatchedDataByNo(url: string, dispatchNo: number) {
    return this.http.get<DispatchedOrder>(url + dispatchNo).pipe(
      catchError(this.handleError('getDispatchedDataByNo()', []))
    );
  }
  getimageByProductName(url: string, path: string) {
    return this.http.get<any>(url + path).pipe(
      catchError(this.handleError('getimageByProductName', []))
    );
  }
  getOrderDetailByOrderNo(url: string, orderNo: string) {
    return this.http.get<any>(url + '/' + orderNo)
    // .pipe(
    //   catchError(this.handleError('getOrderDetailByOrderNo', []))
    // );
  }
  getDispatchMakeToOrderInitialData(url: string, locId: number) {
    return this.http.get<any>(url + '/' + locId)
    // .pipe(
    // catchError(this.handleError('getDispatchMakeToOrderInitialData', []))
    // );
  }
  getDetailsByDateAndCurrentStatus(url: string, req: any) {
    return this.http.post(url, req)
    // .pipe(
    //   catchError(this.handleError('getDetailsByDateAndCurrentStatus()', []))
    // );
  }

  //ReceiveGoodsReturn
  getReceiveGoodsReturnInitialData(url: string, locationId: number) {
    return this.http.get<any>(url + '/' + locationId).pipe(
      catchError(this.handleError('getReceiveGoodsReturnInitialData()', []))
    );
  }
  getReceiveGoodsReturnNo(url: string, req: RequestView) {
    return this.http.post(url, req).pipe(
      catchError(this.handleError('getReceiveGoodsReturnNo()', []))
    );
  }
  getOrderdetailsByReceiveGoodsReturnNo(url: string, orderNo: string) {
    return this.http.get(url + '/' + orderNo).pipe(
      catchError(this.handleError('getOrderdetailsByReceiveGoodsReturnNo()', []))
    );
  }
  getReceiveGoodsReturnNoByLocAndInvAndDate(url: string, requestView: RequestView) {
    return this.http.post(url, requestView).pipe(
      catchError(this.handleError('getReceiveGoodsReturnNoByLocAndInvAndDate()', []))
    );
  }
  getReceiveGoodsReturnNoByLocAndInventory(url: string, locCode: number, inventoryId: number, receiveNo: string) {
    return this.http.get(url + "/" + locCode + "/" + inventoryId + "/" + receiveNo).pipe(
      catchError(this.handleError('getReceiveGoodsReturnNoByLocAndInventory()', []))
    );
  }


  //Goods Return 
  getOrderManagementInitialData(url: string, locationId: number, inventoryId: number) {
    return this.http.get<any>(url + locationId + '/' + inventoryId).pipe(
      catchError(this.handleError('getOrderManagementInitialData()', []))
    );
  }

  getGoodsReturnNoByLocAndInventory(url: string, locCode: number, inventoryId: number, returnNo: string) {
    return this.http.get(url + locCode + '/' + inventoryId + "/" + returnNo).pipe(
      catchError(this.handleError('getGoodsReturnNoByLocAndInventory()', []))
    );
  }

  //MakeToPayment
  getMakePaymentDetails(url: string, code: number) {
    return this.http.get(url + "/" + code)
    // .pipe(
    //   catchError(this.handleError('getMakePaymentDetails()', []))
    // );
  }
  collectPayByVpa(url: string, obj: any) {
    return this.http.post(url, obj)
    // .pipe(
    //   catchError(this.handleError('collectPayByVpa()', []))
    // );
  }
  sendIntentSms(url: string, code: any) {
    return this.http.get(url + "?LocId=" + code, code)
    // .pipe(
    //   catchError(this.handleError('collectPayByVpa()', []))
    // );
  }
  getQrForMakePaymentUpi(url: string, amount: any, LocId: any, paymentType: any) {
    return this.http.get(url + "?amount=" + amount + "?LocId=" + LocId + "?paymentType=" + paymentType(amount, LocId, paymentType))
    // .pipe(
    //   catchError(this.handleError('getQrForMakePaymentUpi()', []))
    // );
  }

  //ManageCrates CrateCount
  getAllCrates(url: string) {
    return this.http.get(url)
    // .pipe(
    //   catchError(this.handleError('getAllCrates()', []))
    // );
  }

  //ManageCrates Receive
  getManageCratesReceiveInitialData(url: string, locCode: number) {
    return this.http.get<any>(url + "/" + locCode)
    // .pipe(
    //   catchError(this.handleError('getManageCratesReceiveInitialData()', []))
    // );
  }
  getCrateSendNoByToLocCode(url: string, obj: RequestView) {
    return this.http.post(url, obj)
    // .pipe(
    //   catchError(this.handleError('getCrateSendNoByToLocCode()', []))
    // );
  }
  getCrateReceiveNos(url: string, requestView: RequestView) {
    return this.http.post(url, requestView)
    // .pipe(
    //   catchError(this.handleError('getCrateReceiveNos()', []))
    // );
  }
  crateReceiveGetById(url: string, code: number) {
    return this.http.get(url + "/" + code)
    // .pipe(
    //   catchError(this.handleError('crateReceiveGetById()', []))
    // );
  }
  getCrateReceiveByLocationAndStatus(url: string, locCode: number, receiveNo: string) {
    return this.http.get(url + "/" + locCode + "/" + receiveNo)
    // .pipe(
    //   catchError(this.handleError('getCrateReceiveByLocationAndStatus()', []))
    // );
  }

  //ManageCrates Send
  getManageCratesSendInitialData(url: string, locCode: number) {
    return this.http.get<any>(url + "/" + locCode)
    // .pipe(
    //   catchError(this.handleError('getManageCratesInitialData()', []))
    // );
  }
  getLocationsByParentLocCode(url: string, locCode: number) {
    return this.http.get(url + "/" + locCode)
    // .pipe(
    //   catchError(this.handleError('getLocationsByParentLocCode()', []))
    // );
  }
  getCrateSendNumberByLocation(url: string, requestView: RequestView) {
    return this.http.post(url, requestView).pipe(
      catchError(this.handleError('getCrateSendNumberByLocation()', []))
    );
  }
  crateSendGetById(url: string, code: number) {
    return this.http.get(url + "/" + code)
    // .pipe(
    //   catchError(this.handleError('crateSendGetById()', []))
    // );
  }
  getCrateSendByLocationAndStatus(url: string, locCode: number, sendNo: number) {
    return this.http.get(url + "/" + locCode + "/" + sendNo)
    // .pipe(
    //   catchError(this.handleError('getCrateReceiveByLocationAndStatus()', []))
    // );
  }

  //View/Process Order
  getInventoryType(url: string) {
    return this.http.get<InventoryType[]>(url).pipe(
      catchError(this.handleError('getInventoryType()', []))
    );
  }
  process(url: string, req: RequestView) {
    return this.http.post(url, req).pipe(
      catchError(this.handleError('process()', []))
    );
  }
  getMatrixByInventoryCode(url: string, inventoryId: number) {
    return this.http.get<ProductMatrix[]>(url + '/' + inventoryId).pipe(
      catchError(this.handleError('getMatrixByInventoryCode()', []))
    );
  }
  getProductGroupByMatrix(url: string, productMatrixId: string) {
    return this.http.get<ProductMatrix[]>(url + '/' + productMatrixId).pipe(
      catchError(this.handleError('getProductGroupByMatrix()', []))
    );
  }
  getOrderNos(url: string, req: RequestView) {
    return this.http.post(url, req).pipe(
      catchError(this.handleError('getOrderNos()', []))
    );
  }

  //Receive order stock
  getInitialData(url: string, locationId: number) {
    return this.http.get<any>(url + '/' + locationId).pipe(
      catchError(this.handleError('getInitialData()', []))
    );
  }
  getDispatchNo(url: string, req: RequestView) {
    return this.http.post(url, req).pipe(
      catchError(this.handleError('getDispatchNo()', []))
    );
  }
  getOrderdetailsByDispatchNo(url: string, orderNo: string) {
    return this.http.get<ReceiveDetail>(url + '/' + orderNo).pipe(
      catchError(this.handleError('getOrderdetailsByDispatchNo()', []))
    );
  }
  getLocationWithParentLocationDetailsByLocCode(url: string, locId: number) {
    return this.http.get(url + '/' + locId)
      .pipe(
        catchError(this.handleError('getLocationWithParentLocationDetailsByLocCode()', []))
      );
  }



  rawMaterialsInitialData(url: string, locationId: number, inventoryId: number) {
    return this.http.get<any>(url + locationId + '/' + inventoryId)
    // .pipe(
    // catchError(this.handleError('rawMaterialsInitialData()', []))
    // );
  }
  getProductGroupsbyMatrixBySetup(url: string, productMatrixId: number, locationId: number) {
    return this.http.get<any>(url + '/' + productMatrixId + '/' + locationId)
    // .pipe(
    //   catchError(this.handleError('getProductGroupsbyMatrixbySetup()', []))
    // );
  }
  getProductSubGroupByGroupCode(url: string, productGroupCode: string | number) {
    return this.http.get<any>(url + '/' + productGroupCode)
    // .pipe(
    //   catchError(this.handleError('getProductSubGroupByGroupCode()', []))
    // );
  }
  getProductFromInventorytypeNameWeb(url: string, inventoryId: number, companyCode: number, word: string) {
    return this.http.get<any>(url + inventoryId + '/' + companyCode + '/' + word)
    // .pipe(
    //   catchError(this.handleError('getProductFromInventorytypeNameWeb()', []))
    // );
  }

  getProductOffersByProductAndLoc(url: string, productId: number, locCode: number) {
    return this.http.get<any>(url + productId + '/' + locCode)
    // .pipe(
    //   catchError(this.handleError('getProductOffersByProductAndLoc()', []))
    // );
  }

  getReceiveGoodsReturnByReceiveNo(url: string, receiveNo: string) {
    return this.http.get(url + "/" + receiveNo)
      .pipe(
        catchError(this.handleError('getReceiveGoodsReturnByReceiveNo()', []))
      );
  }
  getProductsBySubGroupCode(url: string, productSubGroupCode: number, locationId: number) {
    return this.http.get<any>(url + productSubGroupCode + '/' + locationId)
    // .pipe(
    //   catchError(this.handleError('getProductsBySubGroupCode()', []))
    // );
  }
  getParentLocationCode(url: string, locId: number) {
    return this.http.get<any>(url + '/' + locId)
      .pipe(
        catchError(this.handleError('getParentLocationCode()', []))
      );
  }
  getParentLocationName(url: string, locId: number) {
    return this.http.get<Company[]>(url + '/' + locId)
      .pipe(
        catchError(this.handleError('getParentLocationName()', []))
      );
  }
  getlocationscodeByparentLocation(url: string, locId: number) {
    return this.http.get<Location[]>(url + '/' + locId)
    // .pipe(
    //   catchError(this.handleError('getlocationscodeByparentLocation()', []))
    // );
  }
  getAllLocationsByParentAndInv(url: string, locationCode: number, invCode: number) {
    return this.http.get<any[]>(url + '/' + locationCode + '/' + invCode);
  }
  getsaveProductsByLocation(url: string, locId: number, inventoryId: number) {
    return this.http.get<any>(url + '/' + locId + '/' + inventoryId)
      .pipe(
        catchError(this.handleError('getsaveProductsByLocation()', []))
      );
  }
  resetById(url: string, orderNo: string) {
    return this.http.delete(url + '/' + orderNo);
  }
  cancelById(url: string, orderNo: string) {
    return this.http.delete(url + "/" + orderNo);
  }

  cancelByIdGoodsReturn(url: string, orderNo: string) {
    return this.http.patch(url + "/" + orderNo, [{ responseType: 'json' }]);
  }

  orderStockById(url: string, orderNo: number) {
    return this.http.get<OrderStock[]>(url + '/' + orderNo)
      .pipe(
        catchError(this.handleError('orderStockById()', []))
      );
  }
  byTypeAndCompanyCode(url: string, type: string, compCode: number) {
    return this.http.get<Terms[]>(url + '/' + type + '/' + compCode)
      .pipe(
        catchError(this.handleError('byTypeAndCompanyCode()', []))
      );
  }
  getprintsetup(url: string, compCode: number) {
    return this.http.get<Terms[]>(url + '/' + compCode)
      .pipe(
        catchError(this.handleError('getprintsetup()', []))
      );
  }
  Declaration(url: string, compCode: number) {
    return this.http.get<Terms[]>(url + '/' + compCode)
      .pipe(
        catchError(this.handleError('Declaration()', []))
      );
  }
  //Export Data to CSV
  exportOrderStock(url: string, exportType: string, module: string, req: RequestView) {
    if (module === 'Promotion master')
      url = this.apiFactory.exportCsvForPromotions;

    return this.http.post(url + "/" + exportType + "/" + module, req, { responseType: 'arraybuffer' }).pipe(
      catchError(this.handleError('exportOrderStock()', []))
    );
  }
  getGstSaleInvCumBosByInvNo(url: string, invNo: string) {
    return this.http.get<any>(url + '/' + invNo)
      .pipe(
        catchError(this.handleError('getGstSaleInvCumBosByInvNo()', []))
      );
  }

  getShowImageByCompanyAndType(url: string, locationId: number, type: string) {
    return this.http.get<any>(url + '/' + locationId + '/' + type)
  }

}
